import React from "react";

import { getJarisMerchantPortfolioUrl } from "globalConstants";

import styles from "./layout.module.scss";

type JarisBankInfoNoticeProps = {
	jarisMerchantId?: string;
	jarisShopId?: string;
};

type SyncedSystem = {
	name: string;
	href?: string | null;
};

/**
 * Shown above Bank Info on the merchant edit form when the merchant's settlement
 * account is managed through Jaris. Saving bank info here syncs it to every
 * system listed - add an entry to `systems` when a new integration lands.
 */
export const JarisBankInfoNotice = ({
	jarisMerchantId,
	jarisShopId,
}: JarisBankInfoNoticeProps) => {
	const systems: SyncedSystem[] = [
		{
			name: "Jaris",
			href: getJarisMerchantPortfolioUrl(jarisMerchantId, jarisShopId),
		},
		{ name: "TSYS" },
	];

	return (
		<div className={styles.jarisBankInfoNotice}>
			Changes saved here sync automatically to{" "}
			{systems.map((system, index) => (
				<React.Fragment key={system.name}>
					{index > 0 &&
						(index === systems.length - 1 ? " and " : ", ")}
					{system.href ? (
						<a href={system.href} target="_blank" rel="noreferrer">
							{system.name}
						</a>
					) : (
						system.name
					)}
				</React.Fragment>
			))}
			.
		</div>
	);
};
